import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';
import Chooser, {
  StepContainer, StepIntroContainer, ChoicesContainer, Choice, ChoiceTitle,
  PredefinedStepNumber, PredefinedStepTitle, PredefinedStepContainer, PredefinedStepChoice,
  PredefinedWorkflowContainer, PredefinedWorkflowProgressBar, Result,
  ResultsContainer, ResultTitle, ResultDescription, DownloadLink, DownloadTitle, NoResults,
} from '@tenetpartners/chooser';
import { buttonStyles, buttonTextStyles } from '../button/button';

const getChooser = async () => {
  const response = await fetch('/template-chooser.json', {
    headers: {
      'Cache-Control': 'no-cache',
    },
  });
  const data = await response.json();
  return data;
};

const ChooserLoader = ({ data }) => {
  const { steps, templates, initialStepId } = data;
  return (
    <>
      <Chooser
        steps={steps}
        results={templates}
        initialStepId={initialStepId}
        predefinedWorkflow={[
          { title: 'Brand' },
          { title: 'Template' },
          { title: 'Region' },
          { title: 'Classification' },
          { title: 'Results' },
        ]}
        overrideStyles={{
          [StepContainer]: {
            px: ['1.4rem', '2.8rem', '6.4rem'],
            pt: '8rem',
            pb: '10rem',
            m: 0,
          },
          [StepIntroContainer]: {
            color: 'SecondaryBlue2',
            fontSize: '4rem',
            px: [null, '3.6rem', 0],
            mb: [null, '4rem'],
          },
          [ChoicesContainer]: {
            gridTemplateColumns: ['1fr', '1fr 1fr'],
          },
          [Choice]: {
            ...buttonStyles,
            bg: 'PrimaryDarkBlue',
          },
          [ChoiceTitle]: {
            ...buttonTextStyles,
            border: 0,
            p: 0,
            '&:hover': {
              bg: 'transparent',
            },
          },
          [PredefinedStepTitle]: {
            textTransform: 'uppercase',
            color: 'white',
            letterSpacing: '0.1em',
            display: ['none', null, 'block'],
            fontSize: '2.2rem',
            fontWeight: 'bold',
            mb: '1rem',
          },
          [PredefinedStepNumber]: {
            bg: 'white',
            color: 'PrimaryDarkBlue',
            fontSize: '2.4rem',
            fontWeight: 'bold',
            width: '4rem',
            height: '4rem',
            lineHeight: '3.5rem',
            '&.chosen': {
              bg: 'PrimaryDarkBlue',
              color: 'white',
            },
          },
          [PredefinedStepChoice]: {
            color: 'white',
            display: ['none', null, 'block'],
            mt: '1rem',
          },
          [PredefinedWorkflowContainer]: {
            bg: 'SecondaryBlue2',
          },
          [PredefinedStepContainer]: {
            height: ['95px', null, '163px'],
            alignItems: 'center',
            px: '10%',
          },
          [PredefinedWorkflowProgressBar]: {
            height: '2px',
            bg: 'white',
            opacity: 1,
            backgroundImage: 'none',
            width: 'auto',
            top: '50%',
            left: [0, '2.8rem', '6.4rem'],
            right: [0, '2.8rem', '6.4rem'],
          },
          [Result]: {
            img: {
              order: 1,
              border: '1px solid #ccc',
            },
          },
          [ResultsContainer]: {
            gridRowGap: '8rem',
            gridColumnGap: '3.2rem',
            gridTemplateColumns: ['1fr', '1fr 1fr', '1fr 1fr 1fr'],
          },
          [ResultTitle]: {
            color: 'black',
            fontSize: '1.8rem',
            fontWeight: 'bold',
            mt: '1.7rem',
            order: 2,
          },
          [ResultDescription]: {
            color: 'black',
            fontSize: '1.8rem',
            m: 0,
            order: 3,
          },
          [DownloadLink]: {
            ...buttonStyles,
            border: 0,
            order: 4,
          },
          [DownloadTitle]: {
            ...buttonTextStyles,
          },
          [NoResults]: {
            color: 'SecondaryBlue2',
            fontSize: '4rem',
          },
        }}
        onDownload={null}
        //onDownload={(file) => {
        //  //console.log('downloaded', file);
        //}}
      />
    </>
  );
};

ChooserLoader.propTypes = {
  data: PropTypes.shape({
    steps: PropTypes.object.isRequired,
    templates: PropTypes.array.isRequired,
    initialStepId: PropTypes.string.isRequired,
  }).isRequired,
};

const TemplateChooser = () => {
  const { status, data, error } = useQuery('template-chooser', getChooser);

  return (
    <div>
      {status === 'loading' && <span>Loading...</span>}
      {status === 'error' && (
        <span>
          Error:
          {error.message}
        </span>
      )}
      {status === 'success' && <ChooserLoader data={data} />}
    </div>
  );
};

TemplateChooser.propTypes = {

};

export default TemplateChooser;
